<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-layout row>
        <v-flex>
          <dt-search-box @typing="searchValue" @reset-datatable="resetDataTable()" @clear-search-field="search = null">
            <!--            <template v-slot:form="searchSlot">-->
            <!--              <v-layout row wrap>-->
            <!--                <v-flex xs12 md3 pa-2>-->
            <!--                  <v-autocomplete-->
            <!--                    v-model="advancedSearch.type"-->
            <!--                    :items="supplierTypeList"-->
            <!--                    :label="`${$t('Type')}`"-->
            <!--                    auto-select-first-->
            <!--                    hide-details-->
            <!--                    :error="errors.has('individual or company')"-->
            <!--                    data-vv-name="individual_or_company"-->
            <!--                    :menu-props="{ transition: 'slide-y-transition' }"-->
            <!--                  />-->
            <!--                </v-flex>-->

            <!--                <v-flex xs12 md3 pa-2>-->
            <!--                  <v-autocomplete-->
            <!--                    v-model="advancedSearch.country"-->
            <!--                    :items="countriesList"-->
            <!--                    :label="`${$t('Country')}`"-->
            <!--                    height="30px"-->
            <!--                    auto-select-first-->
            <!--                    hide-details-->
            <!--                    data-vv-name="vender_country"-->
            <!--                    :menu-props="{ transition: 'slide-y-transition' }"-->
            <!--                  />-->
            <!--                </v-flex>-->

            <!--                <v-flex xs12 md3 pa-2>-->
            <!--                  <v-text-field-->
            <!--                    v-model="advancedSearch.governorate"-->
            <!--                    :label="$t('Governorate')"-->
            <!--                    data-vv-name="vender_governorate"-->
            <!--                    hide-details-->
            <!--                    autocomplete="off"-->
            <!--                    :error="errors.has('vender_governorate')"-->
            <!--                  />-->
            <!--                </v-flex>-->

            <!--                <v-flex xs12 md3 pa-2>-->
            <!--                  <v-text-field-->
            <!--                    v-model="advancedSearch.city"-->
            <!--                    :label="$t('City')"-->
            <!--                    data-vv-name="vender_city"-->
            <!--                    hide-details-->
            <!--                  />-->
            <!--                </v-flex>-->

            <!--                <v-layout justify-end align-center>-->
            <!--                  <v-flex shrink>-->
            <!--                    <v-btn flat class="grey&#45;&#45;text" @click="searchSlot.reset">-->
            <!--                      <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">clear</v-icon>-->
            <!--                      {{ $t('datatable-reset') }}-->
            <!--                    </v-btn>-->
            <!--                    <v-btn color="success" @click="searchSlot.search">-->
            <!--                      <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">filter_list</v-icon>-->
            <!--                      {{ $t('Filter') }}-->
            <!--                    </v-btn>-->
            <!--                  </v-flex>-->
            <!--                </v-layout>-->
            <!--              </v-layout>-->
            <!--            </template>-->
          </dt-search-box>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card flat>
      <v-layout row>
        <v-layout row wrap justify-start align-end>
          <v-flex pa-2>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin:0 10px 0; height: 30px; width: 30px;"
                  :loading="loadThePrintBtn"
                  flat
                  fab
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('print')"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Print Table`) }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin: 0; height: 30px; width: 30px"
                  fab
                  :loading="loadTheExportBtn"
                  flat
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('export')"
                >
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Export Table`) }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row justify-end>
          <v-flex shrink pa-2>
            <v-btn dark color="primary" v-if="hasPermissions(['vender_store'])" @click="dialogs.addDialog = true">
              <v-icon>add</v-icon>
              {{ $t('datatable-add-new') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4">
      <v-data-table
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.vender_id }}</td>-->
          <td>{{ props.item.vender_name }}</td>
          <td>{{ $t(props.item.individual_or_company) }}</td>
          <td>{{ props.item.vender_phone }}</td>
          <td>{{ props.item.vender_mail }}</td>
          <td>{{ returnCountryName(props.item.vender_country) }}</td>
          <td>{{ props.item.vender_governorate }}</td>
          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon class="transparent py-2" slot="activator">
                <v-icon large class="grey--text actions-btn">
                  <!-- <v-icon large class="mr-2 grey--text actions-btn" @click="editItem(props.item)"> -->
                  more_vert
                </v-icon>
              </v-btn>
              <v-list>
                <v-tooltip v-if="hasPermissions(['vender_show'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="viewRecord(props.item.vender_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('View Supplier Information') }}</span>
                </v-tooltip>

                <v-tooltip v-if="hasPermissions(['vender_update'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="editRecord(props.item.vender_id)">
                    <v-icon>edit</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-edit') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('Edit Supplier Information') }}</span>
                </v-tooltip>

                <v-divider v-if="hasPermissions(['vender_destroy'])" />
                <v-tooltip v-if="hasPermissions(['vender_destroy'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="showConfirmDeletion(props.item.vender_id)">
                    <v-icon class="red--text">delete</v-icon>
                    <v-list-tile-content class="red--text px-3">{{ $t('datatable-delete') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('Delete Supplier Record') }}</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Dialogs %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->

    <view-supplier :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <add-supplier
      :addDialog="dialogs.addDialog"
      @reset-datatable="resetDataTable(), resetAllErrors(true)"
      @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)"
    />

    <edit-supplier
      :editDialog="dialogs.editDialog"
      @updated="updateDatatableResult(), (dialogs.editDialog = false), (allowGettingData = false)"
      @hidemodal="resetAllErrors(true), (dialogs.editDialog = false)"
    />

    <confirm-deletion
      :deleteDialog="dialogs.deleteDialog"
      :btnDeleteLoading="btnDeleteLoading"
      @hidemodal="dialogs.deleteDialog = false"
      @confirm="deleteAction()"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue'),
    dtAdvancedSearch: () => import('@/views/_partials/AppDatatableAdvancedSearch.vue'),
    viewSupplier: () => import('./viewSupplier.vue'),
    addSupplier: () => import('./addSupplier.vue'),
    editSupplier: () => import('./editSupplier.vue')
  },

  data() {
    return {
      advancedSearch: {},
      btnSearchLoading: false,
      dialogs: {
        viewDialog: false,
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        printExportDialog: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      deleteId: 0,
      btnDeleteLoading: false,
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'vender_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'vender_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: this.$t('Supplier Name'), value: 'vender_name' },
        { text: this.$t('Type'), value: 'individual_or_company' },
        { text: this.$t('Phone'), value: 'vender_phone' },
        { text: this.$t('Email'), value: 'vender_mail' },
        { text: this.$t('Country'), value: 'vender_country' },
        { text: this.$t('Governorate'), value: 'vender_governorate' }
      ],
      allowGettingData: true,
      staffMemberId: 0,
      staffMemberFullName: ''
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Suppliers'),
      icon: 'fa-user-friends'
    })

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false
      })
    }
  },

  computed: {
    ...mapGetters({
      resultData: 'suppliers/getSuppliersList',
      supplierTypeList: 'suppliers/getSupplierTypeList',
      countriesList: 'locale/getCountriesList'
    })
  },

  watch: {
    pagination: {
      immediate: true,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'suppliers/updateSuppliersList',
      deleteRecord: 'suppliers/deleteSupplier',
      fetchSupplierInfo: 'suppliers/fetchSupplierInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions(['vender_show', 'vender_update', 'vender_destroy'])
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get(`venders_index`, {
        params: { is_paginated: 0, search: this.search, ...this.advancedSearch }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    updateDatatableResult() {
      this.loading = true
      let payload = { ...this.pagination, search: this.search, advancedSearch: this.advancedSearch }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.allowGettingData = true
      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.advancedSearch = {}
      this.search = this.oldSearch = null
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.search = val

      if (this.oldSearch === this.search) {
        this.updateDatatableResult()
      }
    },

    viewRecord(id) {
      this.fetchSupplierInfo(id).then(() => {
        this.dialogs.viewDialog = true
      })
    },

    editRecord(id) {
      this.fetchSupplierInfo(id).then(() => {
        this.dialogs.editDialog = true
      })
    },

    showConfirmDeletion(id) {
      this.deleteId = id
      this.dialogs.deleteDialog = true
    },

    deleteAction() {
      this.btnDeleteLoading = true
      this.deleteRecord(this.deleteId)
        .then(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
          let payload = { ...this.pagination, search: this.search }
          this.updateResult(payload)
        })
        .catch(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
        })
    },

    returnCountryName(countryId) {
      return helpers.getCountryName(countryId)
    }
  }
}
</script>

<style scoped />
